import config from '@/config/global'

let cacheToken = null
let cacheStoreConfig = null

export default function () {
  const getToken = async () => {
    if(!cacheToken) {
      cacheToken = request({
        method: 'get',
        url: 'v4/checksession'
      },
      null,
      'iamUrl')
      setTimeout(() => cacheToken=null, 10 * 60 * 1000)
    }

    try {
      const { token } = await cacheToken
      return token
    } catch (err) {
      console.error(err.stack)
    }
    return null
  }

  const getStoreConfig = async () => {
    if (!cacheStoreConfig) {
      cacheStoreConfig = this.xhr({
        baseURL: config.API,
        method: 'get',
        url: 'webappconfig'
      })
    }

    try {
      const storeConfig = await cacheStoreConfig
      return storeConfig
    } catch (err) {
      console.error(err.stack)
    }
    return null
  }

  const request = async (options, bearer = false, storeConfigKey) => {
    const storeConfig = await getStoreConfig()
    options.baseURL = storeConfig[storeConfigKey]

    options.headers = options.headers || {}
    if (bearer) {
      let token = await getToken()
      if (token) options.headers.Authorization = `Bearer ${token}`
    }
    return this.xhr(options)
  }

  return {
    async getToken() { return getToken() },
    async organizations () {
      return request({
        method: 'get',
        url: 'v1/organizations'
      },
      true,
      'orgaUrl')
    }
  }
}
